import React, { useState, useEffect } from 'react';
import properties from '../../../modules/ajio-util/properties';
import { getmaskedPrice } from '../../../utils/pdp';
import PriceRevealDialog from './PriceRevealDialog';
import { displayValueWithSymbol } from '../../../utils/price';
import { replaceWithJioCDN } from '../../../utils/imageHandling';


const ProductPriceRevealV2 = props => {
  const {
    prodData = '',
    btnLabel: { btn, shownToUser } = {},
    revealPriceCH,
    priceRevealSaveToClosetCH,
    priceRevealGoToClosetCH,
    saleDuration,
    sendGTMEvent,
    newDesignLuxe,
    earlyAccessData,
    currentStore,
    isEarlyAccessUser,
    bbsPriceForEarlyAccess
  } = props || {};

  let {
    title,
    discountValue,
    description,
    cta,
    userEduText = '',
    priceComingSoonTxt = '',
    price = {},
    futureBestPrice,
    bannerImgSrc
  } = props?.priceRevealData || {};
  const [visibility, setVisibility] = useState(false);

  useEffect(() => {
    document.addEventListener('keydown', e => {
      if (e.code == 'Enter') {
        document.activeElement.click();
      }
    });

    return () => {
      document.removeEventListener('keydown', () => {});
    };
  }, []);

  const getIconsAndHandler = btnLabel => {
    switch (btnLabel) {
      case 'Show BBS Price':
        return { clickHandler: revealPriceCH, btnType: 'btn-gold', icon: '' };
    case 'SAVE TO CLOSET':
    case 'ADD TO WISHLIST':
    case 'SAVE TO WISHLIST':
        return {
          clickHandler: priceRevealSaveToClosetCH,
          btnType: newDesignLuxe ? 'btn-gray' : 'btn-gold',
          icon: newDesignLuxe ? '' : <span className="ic-pdp-closet" />
        };
      case 'GO TO CLOSET':
      case 'GO TO WISHLIST':
        return { clickHandler: priceRevealGoToClosetCH, btnType: 'btn-gray', icon: '' };
      default:
        return { clickHandler: revealPriceCH, btnType: 'btn-gold', icon: '' };
    }
  };
  const getButtons = btnLabel => {
    const { clickHandler, icon, btnType } = getIconsAndHandler(btnLabel) || '';
    return (
      <div className="pr-cta pdp-cart-buttons" onClick={clickHandler} role="button" tabIndex={0}>
        <div className={btnType}>
          {icon}
          <span aria-label={btnLabel}>{btnLabel}</span>
        </div>
      </div>
    );
  };

  const showDialog = () => {
    setVisibility(true);
    sendGTMEvent('what is bbs price?');
  };

  const hideDialog = () => {
    setVisibility(false);
  };

  let productPriceDom = '';
  const getPriceElem = () => {
    if (isEarlyAccessUser) {
      if (bbsPriceForEarlyAccess) {
        productPriceDom = <span className="price">{bbsPriceForEarlyAccess}</span>;
      }
      return null;
    }

    if (shownToUser) {
      if (futureBestPrice > 0) {
        productPriceDom = <span className="price">{displayValueWithSymbol(futureBestPrice)}</span>;
      } else {
        title = priceComingSoonTxt;
        discountValue = '';
      }
    } else {
      productPriceDom = (
        <span className="price">{displayValueWithSymbol(getmaskedPrice(price.value))}</span>
      );
    }
    return null;
  };
  getPriceElem();
  if (isEarlyAccessUser) {
    if (bbsPriceForEarlyAccess) {
      return (
        <div className="price-reveal-widget">
          <div className="early-access-container">
            <div className="img-container">
              <img
                src={replaceWithJioCDN(earlyAccessData?.bannerImgSrc?.image)}
                alt={earlyAccessData?.bannerImgSrc?.altText || 'bbs-logo'}
              />
            </div>
            <div className="info">
              <div className="title ellipsis" aria-label={earlyAccessData?.BBSPriceText}>
                {earlyAccessData?.BBSPriceText}
              </div>
              <div className="price-info ellipsis">
                {productPriceDom}
                {/* {discountValue ? <span className="discount">{`(${discountValue}% off)`}</span> : null} */}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <></>;
    }
  }
  return (
    <div className="price-reveal-widget">
      <div className="container">
        <div className="img-container">
          <img src={replaceWithJioCDN(bannerImgSrc?.image)} alt={bannerImgSrc?.altText || 'bbs-logo'} />
        </div>
        <div className="info">
          <div className="title ellipsis" aria-label={title}>
            {title}
          </div>
          <div className="price-info ellipsis">
            {productPriceDom}
            {discountValue && !newDesignLuxe ? (
              <span className="discount">{shownToUser ? `(${discountValue} % off)` : ''}</span>
            ) : null}
            {discountValue && newDesignLuxe ? (
              <span className="discount">{shownToUser ? `${discountValue}% off` : ''}</span>
            ) : null}
          </div>
          <div className="description ellipsis" aria-label={description}>
            {description}
          </div>
          {!shownToUser && (
            <div
              className="user-edu-text"
              tabIndex={0}
              onClick={showDialog}
              aria-label={userEduText}
            >
              {userEduText}
            </div>
          )}
          {visibility ? (
            <PriceRevealDialog
              visibility={visibility}
              description={description}
              hideDialog={hideDialog}
              setVisibility={setVisibility}
              clickHandler={(...args) => revealPriceCH(...args)}
              newDesignLuxe={newDesignLuxe}
            />
          ) : null}
        </div>
        <div className="tnc" aria-label="&#42; T&C Apply">
          &#42; T&C Apply
        </div>
      </div>
      {cta ? getButtons(btn) : null}
    </div>
  );
};

export default ProductPriceRevealV2;
